export default __webpack_public_path__ + "images/15_habitat.jpg";